/* eslint-disable react/no-children-prop */
import React from 'react';
import { omit } from 'lodash';
import { Mutation } from 'react-apollo';
import { compose, fromRenderProps, mapProps } from 'recompose';

import createPrimaryAsset from './createPrimaryAssetMutation';
import createRelatedAsset from './createRelatedAssetMutation';
import deleteAssets from './deleteAssetsMutation';
import updateAsset from './updateAssetMutation';

import { buildQueryNameForField } from '../../CaseRequestLines/BaseRequestLinesTable/TireOptionsDropdownCell/tireOptionsQuery';
import { CASE_REQUEST_ASSETS_QUERY_NAME } from '../../RequestAssetsForm/withRequestAssets/caseRequestAssetsQuery';

// We reload the Axle Type and Tire Position options
// when the unit type changes, because the axle types depend on it.
const axleTypesQueryName = buildQueryNameForField('axleType');
const tirePositionsQueryName = buildQueryNameForField('tirePosition');

const createMutationFor = mutation => props => (
  <Mutation
    mutation={mutation}
    refetchQueries={() => [
      CASE_REQUEST_ASSETS_QUERY_NAME,
      axleTypesQueryName,
      tirePositionsQueryName,
    ]}
    {...props}
  />
);

const omitReadOnly = vars => omit(vars, 'asset.readOnlyStatus');

const mapMutationProps = (
  mutationPropName,
  loadingPropName,
  varsTransformer = vars => vars,
) => (mutate, { loading }) => ({
  [mutationPropName]: vars => mutate({ variables: varsTransformer(vars) }),
  [loadingPropName]: !!loading,
});

export default compose(
  fromRenderProps(
    createMutationFor(createPrimaryAsset),
    mapMutationProps('createPrimaryAsset', 'creatingPrimary', omitReadOnly),
  ),
  fromRenderProps(
    createMutationFor(createRelatedAsset),
    mapMutationProps('createRelatedAsset', 'creatingRelated', omitReadOnly),
  ),
  fromRenderProps(
    createMutationFor(updateAsset),
    mapMutationProps('updateAsset', 'updating', omitReadOnly),
  ),
  fromRenderProps(
    createMutationFor(deleteAssets),
    mapMutationProps('deleteAssets', 'deleting'),
  ),
  mapProps(
    ({ creatingPrimary, creatingRelated, updating, deleting, ...rest }) => {
      const status = [creatingPrimary, creatingRelated, updating, deleting];

      return { isSavingAssets: status.some(Boolean), ...rest };
    },
  ),
);



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestAssetActions/index.js